import { IconButton, Menu, MenuItem, Stack, useMediaQuery, useTheme } from '@mui/material';
import { MoreVert } from '@mui/icons-material';
import { useState } from 'react';
import ColumnActionButton, { ColumnActionButtonProps } from './ColumnActionButton';

interface ActionCellProps {
  actions: ColumnActionButtonProps[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entry: any;
  maxExpandedActions: number;
}

export default function ActionCell({ actions, entry, maxExpandedActions }: ActionCellProps): React.JSX.Element {
  const theme = useTheme();
  const isBelowBreakpoint = useMediaQuery(theme.breakpoints.down(1080));
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  if (actions.length > maxExpandedActions && isBelowBreakpoint) {
    return (
      <>
        <IconButton size="large" onClick={(e) => setAnchorEl(e.currentTarget)}>
          <MoreVert />
        </IconButton>
        <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
          {actions.map((act, idx) => {
            const isDisabled = typeof act.disabled === 'function' ? act.disabled(entry) : !!act.disabled;
            return (
              <MenuItem
                key={idx}
                disabled={isDisabled || !!act.processing}
                onClick={() => {
                  setAnchorEl(null);
                  act.onClick(entry);
                }}
              >
                {act.icon}
                <span style={{ marginLeft: 8 }}>{act.title}</span>
              </MenuItem>
            );
          })}
        </Menu>
      </>
    );
  }

  return (
    <Stack direction={'row'} justifyContent={'flex-end'}>
      {actions.map((act, idx) => (
        <ColumnActionButton key={idx} entry={entry} {...act} />
      ))}
    </Stack>
  );
}
